import { App } from 'antd';
import { ModalFuncProps } from 'antd/lib/modal';
import classlist from 'utils/classlist';
import TigerModal, { ModalConfig } from './BaseModal';
import './style.scss';

export * from './BaseModal';
export default TigerModal;

/**
 * noStickyBottom: 是否不使用底部吸底
 */
export const openNativeModal = (props: ModalConfig & { noStickyBottom?: boolean }) => {
    const { wrapClassName, transitionName, ...resetProps } = props;

    return TigerModal.open({
        wrapClassName: classlist('comm-modal-wrap portal-modal-wrap', wrapClassName, {
            'modal-no-sticky-bottom': props.noStickyBottom
        }),
        transitionName: classlist('portal-move-down', transitionName),
        maskTransitionName: 'fade',
        ...resetProps
    });
};

export const useAlertModal = () => {
    const { modal } = App.useApp();

    const open = (props: ModalFuncProps) => {
        const { wrapClassName, transitionName, title, ...resetProps } = props;

        modal.info({
            wrapClassName: classlist(
                'common-alert-modal-warp portal-modal-wrap',
                {
                    /**
                     * 按照UI规范要求
                     * 有标题和无标题正文文案颜色不一致
                     * 标题+正文 B1+B2
                     * 只有正文 B1
                     */
                    'has-title': !!title
                },
                wrapClassName
            ),
            icon: null,
            title,
            ...resetProps
        });
    };

    return { open };
};

export const useConfirmModal = () => {
    const { modal } = App.useApp();

    const open = (props: ModalFuncProps) => {
        const { wrapClassName, transitionName, title, ...resetProps } = props;

        return modal.confirm({
            wrapClassName: classlist(
                'common-confirm-modal-warp portal-modal-wrap',
                {
                    'has-title': !!title
                },
                wrapClassName
            ),
            icon: null,
            title,
            ...resetProps
        });
    };

    return { open };
};
